import { render, staticRenderFns } from "./TransferTab3.vue?vue&type=template&id=a46c2c70"
import script from "./TransferTab3.vue?vue&type=script&lang=js"
export * from "./TransferTab3.vue?vue&type=script&lang=js"
import style0 from "./TransferTab3.vue?vue&type=style&index=0&id=a46c2c70&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports